import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'
import Login from '../components/Login'
import Logout from '../components/Logout'
import MainList from '../components/MainList'
import Admin from '../components/Admin'
import PrivacyPolicy from '../components/PrivacyPolicy'
// import Addresses from '../components/Addresses'
import {isAuthorized} from '../lib/common.js'
// import { MdButton, MdContent, MdApp, MdField, MdToolbar, MdList } from 'vue-material/dist/components'
// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

Vue.use(Router)
// Vue.use(MdButton)
// Vue.use(MdContent)
// Vue.use(MdApp)
// Vue.use(MdField)
// Vue.use(MdToolbar)
// Vue.use(MdList)
Vue.use(Vuetify)
// Vue.use(VueMaterial)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: MainList,
      props: {useGps: true, showFilter: false},
      meta: {requiresAuth: true, title: '現在地周辺'}
    },
    {
      path: '/addresses',
      name: 'Addresses',
      component: MainList,
      props: {useGps: false, showFilter: true},
      meta: {requiresAuth: true, title: '住所一覧'}
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {title: '住所検索'}
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/pp',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {title: 'プライバシーポリシー'}
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {title: '管理'}
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log(`beforeEach to:${to.name}`)
  console.log(`router.name ${router.currentRoute.name}`)
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthorized()) {
    // 認証されていなかったときはログイン画面へ
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js